"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactDom = require("react-dom");

var _WindowContext = require("./WindowContext");

var Portal = function Portal(_ref) {
  var children = _ref.children;

  var _useContext = (0, _react.useContext)(_WindowContext.WindowContext),
      targetWindow = _useContext.window;

  var targetDocument = !!targetWindow ? targetWindow.document : document;
  var canCreateElement = !!targetDocument && !!targetDocument.createElement;
  var node = (0, _react.useRef)(); // Remove the portal element from the DOM when unmounting

  (0, _react.useEffect)(function () {
    return function () {
      if (node.current) {
        targetDocument.body.removeChild(node.current);
      }
    };
  }, []);

  if (!canCreateElement) {
    return null;
  }

  if (!node.current) {
    node.current = targetDocument.createElement('div');
    targetDocument.body.appendChild(node.current);
  }

  return (0, _reactDom.createPortal)(children, node.current);
};

Portal.displayName = 'Portal';
var _default = Portal;
exports.default = _default;